/* Mobile products-per-row toggle for sections/shop-product-grid.

   The chosen column count is held on the section wrapper
   (`.wt-shop-grid[data-mobile-columns]`), which the stylesheet reads. This
   element lives inside #ProductGridContainer, which facets.js replaces on every
   filter or sort — so it keeps no state of its own and re-syncs its buttons
   from the wrapper each time a fresh copy connects. */

if (!customElements.get("shop-grid-columns")) {
  class ShopGridColumns extends HTMLElement {
    static storageKey = "shop-grid-mobile-columns";

    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.root = this.closest(".wt-shop-grid");
      if (!this.root) return;
      this.addEventListener("click", this.onClick);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
    }

    onClick(event) {
      const button = event.target.closest("[data-columns]");
      if (!button || !this.contains(button)) return;

      const columns = button.dataset.columns;
      if (this.root.dataset.mobileColumns === columns) return;

      this.root.dataset.mobileColumns = columns;
      try {
        localStorage.setItem(ShopGridColumns.storageKey, columns);
      } catch (e) {
        // Storage unavailable — the choice still applies for this page view.
      }
      this.sync();
    }

    sync() {
      const current = this.root.dataset.mobileColumns;
      this.querySelectorAll("[data-columns]").forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.columns === current),
        );
      });
    }
  }

  customElements.define("shop-grid-columns", ShopGridColumns);
}
